import { ContentCardsSections, useContentCards } from 'common';
import { Widgets } from '~/components/widgets';
import { DataStore } from '~/store';

export const OurOfferings = () => {
  /**
   * Hooks
   */
  const discoverMoreContentCard = useContentCards(
    DataStore,
    ContentCardsSections.discoverMore
  );
  const fundsContentCard = useContentCards(
    DataStore,
    ContentCardsSections.funds
  );
  const investmentsContentCard = useContentCards(
    DataStore,
    ContentCardsSections.investments
  );

  /**
   * DOM
   */
  return (
    <div className="flex flex-col gap-y-6">
      {/** discover more section */}
      <Widgets.WidgetPortfolioHome
        showAccountTypeInfo
        title={discoverMoreContentCard.title}
        card={discoverMoreContentCard.content}
      />
      {/** active funds section */}
      <Widgets.WidgetPortfolioHome
        showAccountTypeInfo
        title={fundsContentCard.title}
        card={fundsContentCard.content}
      />
      {/** investments section */}
      <Widgets.WidgetPortfolioHome
        showAccountTypeInfo
        title={investmentsContentCard.title}
        card={investmentsContentCard.content}
      />
      <Widgets.WidgetPortfolioHome title="Help" showHelpInfo />
    </div>
  );
};
